var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('ImportForm',{on:{"importedFile":_vm.importedFile,"upload":_vm.clearWorkData}}),_c('ProgressBar'),_c('ExpensesImportWorkList',{ref:"workList",staticClass:"mt-4",attrs:{"getListActionName":"finance/fetchAllExpensesImportWork"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }